import type { ToastMessage } from 'primereact/toast';
import { globalToastService } from '@repo/atomic-components';
import { PagesMovedToastDetail } from '../components/PagesMovedToastDetail';

const PAGES_MOVED_TOAST_LIFE_MS = 10 * 1000;

interface PagesMovedToast {
  pageCount: number;
  onJumpToPage: () => void;
}

/** Confirms a move to a section and offers the jump the move itself no longer performs. */
export function showPagesMovedToast({ pageCount, onJumpToPage }: PagesMovedToast) {
  const toast: ToastMessage = {
    severity: 'success',
    summary: 'Pages moved',
    closable: true,
    life: PAGES_MOVED_TOAST_LIFE_MS,
    detail: (
      <PagesMovedToastDetail
        pageCount={pageCount}
        onJumpToPage={() => {
          globalToastService.remove(toast);
          onJumpToPage();
        }}
      />
    ),
  };

  globalToastService.show(toast);
}
